<app-form-control class="form-control">
  <div appFormControlLabel>{{ payload.label }}</div>
  <app-dropdown appFormControlInput [data]="$any(payload.options)" [formControl]="formControl"></app-dropdown>
  <span *ngIf="payload.hint" appFormControlHint>{{ payload.hint }}</span>
</app-form-control>
